import axios from 'axios';
import _ from 'lodash';
import { getISOFromDate } from '../../models/datetime';

const BASE_URL = 'api/sites/';

function getCurrentRentDeal(rentDeals) {
  let dt = new Date();
  let x = rentDeals.find(x => {
    let sd = new Date(x.startedAt);
    let fd = new Date(x.finishedAt);
    return sd <= dt && fd >= dt;
  });

  if (x) return x.costPerMonth
  else return 0;
}

let exports = {};
exports.namespaced = true;

exports.state = () => ({
  sites: [],
  cities: [],
  actualData: [],
  entities: {
    paper: [],
    page: [],
    portfolio: [],
    question: [],
    specialist: [],
    testimonial: [],
    solution: [],
    html: [],
    settings: []
  },
  entitySites: {
    paper: null,
    page: null,
    portfolio: null,
    question: null,
    specialist: null,
    testimonial: null,
    solution: null,
    html: null,
    settings: null
  },
  loading: {
    list: 0,
    save: 0,
    delete: 0,
    updateNotify: 0,
    cities: 0,
    actual: 0,
    entities: {
      paper: { list: 0, save: 0, delete: 0 },
      page: { list: 0, save: 0, delete: 0 },
      portfolio: { list: 0, save: 0, delete: 0 },
      question: { list: 0, save: 0, delete: 0 },
      specialist: { list: 0, save: 0, delete: 0 },
      testimonial: { list: 0, save: 0, delete: 0 },
      solution: { list: 0, save: 0, delete: 0 },
      html: { list: 0, save: 0, delete: 0 },
      settings: { list: 0, save: 0, delete: 0 },
    }
  },
  timeZones: [
    {
      text: 'МСК -1',
      value: 2
    },
    {
      text: 'МСК',
      value: 3
    },
    {
      text: 'МСК +1',
      value: 4
    },
    {
      text: 'МСК +2',
      value: 5
    },
    {
      text: 'МСК +3',
      value: 6
    },
    {
      text: 'МСК +4',
      value: 7
    },
    {
      text: 'МСК +5',
      value: 8
    },
    {
      text: 'МСК +6',
      value: 9
    },
    {
      text: 'МСК +7',
      value: 10
    },
  ],
});

exports.getters = {
  getSiteById: state => id => state.sites.find(x => x._id == id),
  getEntity: state => (tag, id) => {
    let items = [];
    switch (tag) {
      case 'paper': items = state.entities.paper; break;
      case 'page': items = state.entities.page; break;
      case 'portfolio': items = state.entities.portfolio; break;
      case 'question': items = state.entities.question; break;
      case 'specialist': items = state.entities.specialist; break;
      case 'testimonial': items = state.entities.testimonial; break;
      case 'solution': items = state.entities.solution; break;
      case 'html': items = state.entities.html; break;
      case 'settings': items = state.entities.settings; break;
    };
    return items.find(x => x._id == id);
  },
  sitesSelectData: state => state.sites.map(x => ({
    text: `${x.name} (${x.city.name})`,
    value: x._id
  })),
  loadingList: state => state.loading.list != 0,
  loadingActualData: state => state.loading.actual != 0,
  loadingSave: state => state.loading.save != 0,
  loadingDelete: state => state.loading.delete !=0,
  loadingUpdateNotify: state => state.loading.updateNotify != 0,
  loadingCities: state => state.loading.cities != 0,
  loadingEntity: state => (tag, action) => state.loading.entities[tag][action] != 0,
  testimonialsSelectData: state => state.entities.testimonial.map(x => ({
    value: x._id,
    text: `${x.objectName} / Клиент ${x.customerName}${x.site ? ' ' + x.site.name : ''}`
  }))
}

exports.mutations = {
  SET_SITES_LIST(state, sites) {
    state.sites = sites;
  },
  SET_CITIES_LIST(state, cities) {
    state.cities = cities;
  },
  SET_LOADING_STATUS(state, action) {
    state.loading[action]++;
  },
  REMOVE_LOADING_STATUS(state, action) {
    state.loading[action]--;
  },
  SET_ENTITIES_LIST(state, { tag, entities }) {
    state.entities[tag] = entities;
  },
  SET_ENTITY_LOADING_STATUS(state, { tag, action }) {
    state.loading.entities[tag][action]++;
  },
  REMOVE_ENTITY_LOADING_STATUS(state, { tag, action }) {
    state.loading.entities[tag][action]--;
  },
  SET_ENTITY_SITE(state, { tag, site }) {
    state.entitySites[tag] = site;
  },
  SET_ACTUAL_DATA(state, dt) {
    state.actualData = dt;
  },
};

exports.actions = {
  async loadList({ commit, dispatch }) {
    commit('SET_LOADING_STATUS', 'list');
    try {
      let res = await axios.get(BASE_URL);
      commit('SET_SITES_LIST', res.data.map(x => {
        let y = {
          ...x,
          currentRentDeal: getCurrentRentDeal(x.rentDeals)
        };
        // Часовой пояс сайта (текст)
        y.timeZoneText = 'МСК';
        if (y.city.timeZone < 3) y.timeZoneText += '-' + (3 - Number(y.city.timeZone));
        if (y.city.timeZone > 3) y.timeZoneText += '+' + (Number(y.city.timeZone) - 3);
        // Телефон (основной)
        y.mainPhone = y.marketingChannels.find(z => z.tagName == '-').phoneNumber;
        if (y.mainPhone) {
          y.mainPhone = '+7(' + (y.city.phone4 ? y.mainPhone.substr(0, 4) : y.mainPhone.substr(0, 3)) +
            ')' + y.mainPhone.substr(y.city.phone4 ? 4 : 3);
        }
        y.rentDeals = x.rentDeals.map(rd => ({
          ...rd,
          _dates: [getISOFromDate(rd.startedAt), getISOFromDate(rd.finishedAt)],
          _num: rd._id.substr(rd._id.length - 3).toUpperCase(),
          _isActive: rd.startedAt < new Date() && rd.finishedAt > new Date(),
          _notifySms: rd.notifySms ? rd.notifySms : '',
          _notifyEmail: rd.notifyEmail ? rd.notifyEmail : '',
          _phoneNumberPrefix: Boolean(rd.notifySms) ? '+7' : '',
          _loadingUpdateSms: false,
          _loadingUpdateEmail: false,
          siteId: y._id
        }));
        y.marketingChannels = x.marketingChannels.map(mc => ({
          ...mc,
          _startedAt: getISOFromDate(mc.startedAt),
          _finishedAt: getISOFromDate(mc.finishedAt),
          _basechannel: mc.tagName == '-'
        }));
        return y;
      }));
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'list');
    }
  },

  async loadCitiesList({ commit, dispatch }) {
    commit('SET_LOADING_STATUS', 'cities');
    try {
      let res = await axios.get(BASE_URL + 'cities');
      commit('SET_CITIES_LIST', res.data);
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'cities');
    }
  },

  async loadActualData({ commit, dispatch }) {
    commit('SET_LOADING_STATUS', 'actual');
    try {
      let res = await axios.get(BASE_URL + 'actual');
      commit('SET_ACTUAL_DATA', res.data);
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_LOADING_STATUS', 'actual');
    }
  },

  async save({ commit, dispatch }, site) {
    commit('SET_LOADING_STATUS', 'save');
    try {
      // Готовим сущность Сайт к загрузке на сервер
      let siteObj = _.cloneDeep(site);
      siteObj.rentDeals.forEach(element => {
        element.partner = element.partner._id
      });
      let res = await axios.post(BASE_URL, siteObj);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'save');
    }
  },

  async updateNotify({commit, dispatch}, { rent, updateType }) {
    commit('SET_LOADING_STATUS', 'updateNotify');
    try {
      let dt = {
        notifySms: updateType == 'sms' ? rent._notifySms : '',
        notifyEmail: updateType == 'email' ? rent._notifyEmail : ''
      };
      let res = await axios.patch(BASE_URL + 'notify/' + rent.siteId + '/' + rent._id, dt);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      return err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'updateNotify');
    }
  },
  
  async delete({ commit, dispatch }, id) {
    commit('SET_LOADING_STATUS', 'delete');
    try {
      let res = await axios.delete(BASE_URL + id);
      dispatch('loadList');
      return res.data;
    } catch(err) {
      //alert(err);
      throw err.response.data;
    } finally {
      commit('REMOVE_LOADING_STATUS', 'delete');
    }
  },

  async loadEntitiesList({ commit,dispatch }, {tag, site, partner }) {
    //console.log(tag);
    commit('SET_ENTITY_LOADING_STATUS', { tag, action: 'list' });
    try {
      commit('SET_ENTITY_SITE', { tag, site });
      let res = await axios.get(BASE_URL + 
        'entities/' + 
        tag + 
        (site ? '?site=' + site : '') +
        (partner ? ((site ? '&' : '?') + 'partner=' + partner) : '')
      );
      commit('SET_ENTITIES_LIST', { tag, entities: res.data });
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
      commit('REMOVE_ENTITY_LOADING_STATUS', { tag, action: 'list' });
    }
  },

  async getEntitiesList({ dispatch }, {tag, site, partner }) {
    try {
      let res = await axios.get(BASE_URL + 
        'entities/' + 
        tag + 
        (site ? '?site=' + site : '') +
        (partner ? ((site ? '&' : '?') + 'partner=' + partner) : '')
      );
      return res.data;
    } catch(err) {
      dispatch('showMessage', err.response.data.message, { root: true });
    } finally {
    }
  },

  async saveEntity({ commit, dispatch, state }, { tag, entity }) {
    commit('SET_ENTITY_LOADING_STATUS', { tag, action: 'save' });
    try {
      if (entity.site === undefined) entity.site = null;
      //console.log(entity);
      let res = await axios.post(BASE_URL + 'entities/' + tag, entity);
      await dispatch('loadEntitiesList', { tag, site: state.entitySites[tag] });
      return res.data;
    } catch(err) {
      console.log(err);
      throw err.response.data;
    } finally {
      commit('REMOVE_ENTITY_LOADING_STATUS', { tag, action: 'save' });
    }
  },

  async deleteEntity({ commit, dispatch, state }, { tag, id }) {
    commit('SET_ENTITY_LOADING_STATUS', { tag, action: 'delete' });
    try {
      let res = await axios.delete(BASE_URL + 'entities/' + tag + '/' + id);
      await dispatch('loadEntitiesList', { tag, site: state.entitySites[tag] });
      return res.data;
    } catch(err) {
      throw err.response.data;
    } finally {
      commit('REMOVE_ENTITY_LOADING_STATUS', { tag, action: 'delete' });
    }
  },
};

export default exports;